<template>
  <div class="skeleton-wrap">
    <div v-for="i in count" :key="i" class="skeleton-row" :class="`variant-${variant}`"></div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    count: { type: Number, default: 4 },
    variant: { type: String, default: 'row' }
  }
}
</script>

<style scoped>
.skeleton-wrap { display: flex; flex-direction: column; gap: var(--spacing-sm); }
.skeleton-row {
  background: linear-gradient(90deg, #eee 0%, #f5f5f5 50%, #eee 100%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: var(--radius-md);
}
.variant-row { height: 56px; }
.variant-card { height: 120px; }
@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
</style>
